/*
 * The Frosted Muzzle — system component list (Phase 4).
 * Listens for `fm:system:configured` (dispatched by the configurator) and
 * updates each component's live "× N in your bundle" quantity. Matches by
 * product id when available, falling back to title. No DOM coupling to the
 * configurator section.
 */
(function () {
  'use strict';

  class SystemComponentList extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-fm-component]'));
      this.onConfigured = this.onConfigured.bind(this);
      document.addEventListener('fm:system:configured', this.onConfigured);

      // Gallery lightbox: one shared <dialog> for every component's thumbnails.
      this.onThumbClick = this.onThumbClick.bind(this);
      this.addEventListener('click', this.onThumbClick);

      // Learn More panels behave as one accordion: opening one closes the rest.
      // `toggle` does not bubble, so listen in the capture phase.
      this.onPanelToggle = this.onPanelToggle.bind(this);
      this.addEventListener('toggle', this.onPanelToggle, true);
    }

    disconnectedCallback() {
      document.removeEventListener('fm:system:configured', this.onConfigured);
      this.removeEventListener('click', this.onThumbClick);
      this.removeEventListener('toggle', this.onPanelToggle, true);
    }

    // --- Learn More accordion ---------------------------------------------

    onPanelToggle(event) {
      var opened = event.target;
      // Only react to a panel being opened; closing one needs no bookkeeping,
      // which also stops the `open = false` writes below from recursing.
      if (!opened || !opened.classList || !opened.classList.contains('fm-components__learn-more')) return;
      if (!opened.open) return;

      var panels = this.querySelectorAll('.fm-components__learn-more[open]');
      for (var i = 0; i < panels.length; i++) {
        if (panels[i] !== opened) panels[i].open = false;
      }
    }

    // --- Gallery lightbox -------------------------------------------------

    ensureDialog() {
      if (this.dialog) return this.dialog;
      var dialog = document.createElement('dialog');
      dialog.className = 'fm-components__lightbox';
      dialog.innerHTML =
        '<button type="button" class="fm-components__lightbox-close" aria-label="Close">&times;</button>' +
        '<img class="fm-components__lightbox-img" alt="">' +
        '<p class="fm-components__lightbox-caption"></p>';
      // Close on the × button or a backdrop click (click landing on the dialog
      // element itself, outside the image). Esc is handled natively by <dialog>.
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog || event.target.closest('.fm-components__lightbox-close')) {
          dialog.close();
        }
      });
      document.body.appendChild(dialog);
      this.dialog = dialog;
      return dialog;
    }

    onThumbClick(event) {
      var thumb = event.target.closest('[data-fm-lightbox]');
      if (!thumb || !this.contains(thumb)) return;
      event.preventDefault();
      var dialog = this.ensureDialog();
      var src = thumb.getAttribute('data-full');
      var alt = thumb.getAttribute('data-alt') || '';
      var img = dialog.querySelector('.fm-components__lightbox-img');
      var caption = dialog.querySelector('.fm-components__lightbox-caption');
      img.setAttribute('src', src);
      img.setAttribute('alt', alt);
      caption.textContent = alt;
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        // Very old browsers without <dialog>: open the image directly.
        window.open(src, '_blank', 'noopener');
      }
    }

    onConfigured(event) {
      var components = (event.detail && event.detail.components) || [];
      this.items.forEach(function (el) {
        var id = el.getAttribute('data-fm-component-id');
        var title = el.getAttribute('data-fm-component-title');
        var match = components.find(function (c) {
          if (id && c.product_id != null) return String(c.product_id) === String(id);
          return c.title === title;
        });
        var qty = match ? match.quantity : 0;
        el.classList.toggle('fm-components__item--inactive', qty <= 0);
      });
    }
  }

  if (!customElements.get('fm-system-component-list')) {
    customElements.define('fm-system-component-list', SystemComponentList);
  }
})();
